<template>
  <vx-card :title="$t('Your wallets')" id="chart-wallet" class-body="pt-1" v-if="dataLen==null || this.dataLen > 0">
    <div class="lg:w-1/2 mx-auto text-center border pb-2 border-solid  border-r-0 border-t-0 border-l-0 d-theme-border-grey-light">
      <p class="mt-4">{{$t('Value of cryptocurrency wallets (in Tomans)')}}</p>
      <p class="mb-4 mt-1 lg:text-xl text-2md font-semibold vazir">{{sumBalancePerInternal.toLocaleString('en-US')}}</p>
    </div>
    <div class="lg:flex justify-between text-center mt-2">
      <div class="lg:w-1/2 w-full border border-solid d-theme-border-grey-light border-r-0 border-t-0">
        <p class="mt-3">{{$t('Toman wallet balance')}}</p>
        <p class="mb-4 mt-1 lg:text-xl text-2md font-semibold vazir">{{balanceWalletInternal.toLocaleString('en-US')}}</p>
      </div>
      <div class="lg:w-1/2 w-full border border-solid d-theme-border-grey-light border-t-0">
        <p class="mt-3">{{$t('Value of cryptocurrency wallets (in usdt)')}}</p>
        <p class="mb-4 mt-1 lg:text-xl text-2md font-semibold">${{sumBalancePerDollar.toLocaleString('en-US')}}</p>
      </div>
    </div>

    <div class="mt-5" v-on:mouseover="mouseOver(1)" v-on:mouseleave="mouseOver(0)">
      <v-chart class="chart" :option="option" ref="pie" manual-update autoresize :style="{height: heightChart,width:'100%'}"/>
    </div>

  </vx-card>
</template>
<i18n locale="fa">
{
  "Your wallets" : "کیف پول های شما"
  ,"Value of cryptocurrency wallets (in Tomans)":"ارزش کیف پول های رمز ارز (به تومان)"
  ,"Toman wallet balance":"موجودی کیف پول تومان"
  ,"Value of cryptocurrency wallets (in usdt)":"ارزش کیف پول های رمز ارز (به دلار)"
}
</i18n>

<script>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { PieChart } from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent
} from "echarts/components";
import VChart,{UPDATE_OPTIONS_KEY} from "vue-echarts";

use([
  CanvasRenderer,
  PieChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent
]);


//import 'echarts/lib/component/tooltip'
//import 'echarts/lib/component/legend'
//import 'echarts/lib/chart/pie'

export default {
  props:['pieChartData','sumBalancePerInternal','balanceWalletInternal','sumBalancePerDollar','gift','levelInfo'],
  computed:{
    heightChart(){
      var height = 350;
      if(this.gift)
        height += 60;
      if(this.levelInfo.dailyWithdrawalCrypto == 0)
        height += 60;
      if(this.islocale == 'en')
        height += 100;
      return height+'px'
    },
    dataLen(){
      return this.pieChartData.length;
    }
  },
  watch:{
    pieChartData(value){
      this.option.series[0].color = this.pieChartData.map(({color}) => color)
      this.option.series[0].data = this.pieChartData
      this.$refs.pie.setOption(this.option);
      this.mouseOver(1);
      this.mouseOver(0);
    },
    '$store.state.theme'(value){
      var color = (value === 'dark') ?'#fff' : '#000';
      const pie = this.$refs.pie
      this.option.legend.textStyle.color = color;
      this.option.legend.pageTextStyle.color = color;
      this.option.series[0].label.textStyle.color = color;
      pie.setOption(this.option);
    }
  },
  data () {
    return {
      interval: null,
      dataIndex: -1,
      option: {
        tooltip: {
          backgroundColor: 'rgba(50,50,50,0.7)',
          trigger: 'item',
          textStyle: {
            fontFamily:'iranyekan,"Montserrat", Helvetica, Arial, sans-serif',
            color: '#fff'
          },
          formatter: function (params) {
            return `${this.localeNameSymbol(params.name)[this.islocale]}(${params.name}):<br> ${params.data.value.toLocaleString('en-US')} ${this.activeUserInfo.internalcurrency_name}
                    <br> (${params.percent}%)`;
          }.bind(this)
        },
        legend: {
          type:'scroll',
          itemGap : 25,
          orient: 'horizontal',
          bottom: 'bottom',
          formatter: function (params) {
            return this.localeNameSymbol(params)[this.islocale]+'('+ params +')'
          }.bind(this),
          textStyle: {
            fontFamily:'iranyekan,"Montserrat", Helvetica, Arial, sans-serif',
            color: (this.$store.state.theme === 'dark') ?'#fff' : '#000',
          },
          pageIconColor:'#01a781',
          pageTextStyle:{
            color: (this.$store.state.theme === 'dark') ?'#fff' : '#000',
          }
        },
        series: [
          {
            name: 'وضعیت کیف پول',
            type: 'pie',
            radius: '65%',
            center: ['50%', '50%'],
            color: this.pieChartData.map(({color}) => color),
            data: this.pieChartData,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            label:{
              borderWidth: 0,
              alignTo: 'none',
              bleedMargin: 5,
              textStyle: {
                fontFamily:'iranyekan,"Montserrat", Helvetica, Arial, sans-serif',
                color:(this.$store.state.theme === 'dark') ?'#fff' : '#000',
              },
              textBorderColor :'transparent',
              fontSize:14
            },
          }
        ]
      }
    }
  },
  methods: {
    mouseOver (status) {
      if (status == 1) {
        window.clearInterval(this.interval)
        const pie = this.$refs.pie
        const dataIndex = this.dataIndex
        pie.dispatchAction({
          type: 'downplay',
          seriesIndex: 0,
          dataIndex
        })
      } else {
        this.intervalActive()
      }
    },
    intervalActive () {
      let dataIndex = this.dataIndex
      const pie = this.$refs.pie
      const dataLen = this.dataLen
      const thisIt = this
      this.interval = setInterval(() => {
        pie.dispatchAction({
          type: 'downplay',
          seriesIndex: 0,
          dataIndex
        })
        dataIndex = (dataIndex + 1) % dataLen
        pie.dispatchAction({
          type: 'highlight',
          seriesIndex: 0,
          dataIndex
        })
        pie.dispatchAction({
          type: 'showTip',
          seriesIndex: 0,
          dataIndex
        })
        thisIt.dataIndex = dataIndex
      }, 1500)
    }
  },
  components: {
    VChart
  },
  created() {
  },
  mounted () {
    this.intervalActive()
  }
}


</script>
<style lang="scss">
  #chart-wallet .echarts div:nth-of-type(2){
      z-index: 99 !important;
  }

</style>
